export * from './loyalty-not-enrolled.styled.default';
